import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";

const Comentarios = ({ comentarios, lang, config, ruta }) => {

    const { t } = useTranslation();

    let coms = [];

    {
        comentarios.forEach((uncomentario, index) => {
            let iconosestrellas = "";
            for (let i = 0; i < uncomentario.estrellas; i++) {
                iconosestrellas += "<i class='fa-solid fa-star' style='color:" + config.color_corporativo_web + "'></i>";
            }

            const primerTitulo = Object.values(uncomentario.titulo || {}).find(Boolean);
            const primerTexto = Object.values(uncomentario.texto || {}).find(Boolean);

            let objeto = {
                id: index,
                identificador: uncomentario.id,
                titulo: uncomentario.titulo?.[lang] || primerTitulo,
                texto: uncomentario.texto?.[lang] || primerTexto,
                estrellas: iconosestrellas,
                persona: uncomentario.nombre_persona,
                propiedad: uncomentario.propiedad ? uncomentario.propiedad.nombre : "",
                imagen: uncomentario.imagen
            }
            coms = coms.concat(objeto);
        })
    }

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.bh-testimonio', coms.length);

    return (
        config.activa_comentarios_web == 1 && comentarios.length > 0 ?
            <Container className="potblur bh-comentarios">
                <div className="bhh-section__head">
                    <span className="bhh-eyebrow">{t("Huéspedes felices")}</span>
                    <h3 className="text-center">{t("Testimonios")}</h3>
                </div>

                <div className="bh-comentarios__carousel">
                    <button
                        type="button"
                        disabled={navState.atStart}
                        onClick={() => scrollByCard(-1)}
                        className="bhh-destacados__prev"
                        aria-label={t("Anterior")}
                    >
                        <i className="fa-solid fa-arrow-left"></i>
                    </button>
                    <div className="bh-comentarios__track" ref={trackRef}>
                        {coms.map((comentario) => (
                            <div className="bh-testimonio" key={comentario.id}>
                                <div className="bh-testimonio__card">
                                    {comentario.imagen &&
                                        <div className="bh-testimonio__avatar">
                                            <img src={ruta + "/comentarios/" + comentario.identificador + "/" + comentario.imagen} alt={comentario.persona} />
                                        </div>
                                    }
                                    <div className="bh-testimonio__estrellas">
                                        {ReactHtmlParser(comentario.estrellas)}
                                    </div>
                                    <div className="bh-testimonio__texto">
                                        {ReactHtmlParser(comentario.texto)}
                                    </div>
                                    <div className="bh-testimonio__persona">{comentario.persona}</div>
                                    {comentario.propiedad && <div className="bh-testimonio__propiedad">{comentario.propiedad}</div>}
                                </div>
                            </div>
                        ))}
                    </div>
                    <button
                        type="button"
                        disabled={navState.atEnd}
                        onClick={() => scrollByCard(1)}
                        className="bhh-destacados__next"
                        aria-label={t("Siguiente")}
                    >
                        <i className="fa-solid fa-arrow-right"></i>
                    </button>
                </div>
            </Container>
            :
            <></>
    );
};
export default Comentarios;
